"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _configuration = require("@/api/configuration");
var _enum = require("@/utils/enum");
var Page = /*#__PURE__*/function (_Vue) {
  function Page() {
    var _this;
    (0, _classCallCheck2.default)(this, Page);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, Page, [].concat(args));
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "config", []);
    (0, _defineProperty2.default)(_this, "ConfigurationParamTrans", _enum.ConfigurationParamTrans);
    (0, _defineProperty2.default)(_this, "ConfigurationParam", _enum.ConfigurationParam);
    (0, _defineProperty2.default)(_this, "loading", false);
    return _this;
  }
  (0, _inherits2.default)(Page, _Vue);
  return (0, _createClass2.default)(Page, [{
    key: "created",
    value: function created() {
      this.fetchData();
    }
  }, {
    key: "handleUpdate",
    value: function () {
      var _handleUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var i, e, value, data, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.loading = true;
              i = 0;
            case 3:
              if (!(i < this.config.length)) {
                _context.next = 14;
                break;
              }
              e = this.config[i];
              value = e.value;
              if (e.param == _enum.ConfigurationParam.VatFactor) {
                value = e.value / 100;
              }
              data = {
                configuration: {
                  value: value
                }
              };
              _context.next = 10;
              return _configuration.configurationApi.update(e.id, data);
            case 10:
              res = _context.sent;
            case 11:
              i++;
              _context.next = 3;
              break;
            case 14:
              this.$notify({
                title: "Update Setting",
                message: "Successfully",
                type: "success"
              });
            case 15:
              _context.prev = 15;
              this.loading = false;
              return _context.finish(15);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0,, 15, 18]]);
      }));
      function handleUpdate() {
        return _handleUpdate.apply(this, arguments);
      }
      return handleUpdate;
    }()
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _configuration.configurationApi.findAll();
            case 2:
              res = _context2.sent;
              this.config = res.data.configurations.map(function (e) {
                if (e.param == _enum.ConfigurationParam.VatFactor) {
                  e.value *= 100;
                }
                return e;
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
Page = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], Page);
var _default = exports.default = Page;